var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Last posts")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"})])])}]

export { render, staticRenderFns }